module.exports = __webpack_public_path__ + "img/h_tutorial_step-2.0abd469c.png";